import { useEffect } from 'react';

/**
 * Keeps the collaborative-presence lease in sync with the resource the user
 * currently has open.
 *
 * Presence is a consequence of *what is active*, never of the gesture that made
 * it active. Asserting it at each selection call site meant every new way of
 * changing the active item (the "Siguiente"/"Anterior" buttons, keyboard
 * shortcuts, the timeline slider, a row click, a deep link) silently shipped
 * without marking the slot. Deriving it from the id instead makes every entry
 * point mark and release identically, and there is only one place to get right.
 *
 * React runs the cleanup of the previous id before the effect of the next one,
 * so switching resources always emits `leaving_*` before `working_*`.
 */
export function usePresenceLease(
  resourceId: string | null | undefined,
  connect: (id: string) => void,
  disconnect: (id: string) => void
) {
  useEffect(() => {
    if (!resourceId) return;

    connect(resourceId);
    return () => disconnect(resourceId);
  }, [resourceId, connect, disconnect]);
}
